import type { EntityType } from "./entity";

// type of updates that are published to the platform
export type UpdateType =
  "OTHER" | "DA" | "EPBC" | "STATUS" | "NEW" | "REVISION" | "ORGANISATION";

export const updateTypes: UpdateType[] = [
  "NEW",
  "OTHER",
  "STATUS",
  "DA",
  "EPBC",
  "ORGANISATION",
  "REVISION",
];

export const defaultUpdateTypes = updateTypes.filter(
  (updateType) => updateType !== "REVISION",
);

export interface Changelog {
  title: string;
  timestamp: Date;
  id: string;
  zoom?: number;
  link_text?: string;
  link_url?: string;
  description: string;
  group_name?: string | null;
  group_rank?: number | null;
  entity_id: string | null;
  related_entity_type: EntityType | null;
  point: [number, number] | null;
  update_type: UpdateType;
  field_name: string | null;
  linked_entity_id?: string | null;
}

export interface ChangelogFeatureProperties {
  id: string;
  entity_type: "changelog";
  title: string;
  description: string;
  update_type: UpdateType;
  timestamp: string;
}

export interface ChangelogUpdateRedirectResponse {
  path: string;
}
